import * as React from "react";

// Navigate
import { useLocation, useNavigate } from "react-router-dom";

// Mui
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
// Mui Style
import {
  StyledAppBar,
  StyledDrawerHeader,
  StyledMain,
} from "@/styles/mui/layoutStyles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import Drawer from "@mui/material/Drawer";
// Mui List
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

// Mui Icon
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CampaignIcon from "@mui/icons-material/Campaign";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CompareIcon from "@mui/icons-material/Compare";
import ComputerIcon from "@mui/icons-material/Computer";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import FlipToBackIcon from "@mui/icons-material/FlipToBack";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import HomeIcon from "@mui/icons-material/Home";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import ListAltIcon from "@mui/icons-material/ListAlt";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import MenuIcon from "@mui/icons-material/Menu";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import MoveDownIcon from "@mui/icons-material/MoveDown";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import OutboxIcon from "@mui/icons-material/Outbox";
import PaymentsIcon from "@mui/icons-material/Payments";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import Receipt from "@mui/icons-material/Receipt";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RedeemIcon from "@mui/icons-material/Redeem";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ScheduleIcon from "@mui/icons-material/Schedule";
import SettingsIcon from "@mui/icons-material/Settings";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import SwapCallsIcon from "@mui/icons-material/SwapCalls";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import Collapse from "@mui/material/Collapse";
import useMediaQuery from "@mui/material/useMediaQuery";
// Redux
import {
  resetDataTable,
  setCollapseOpen,
  setGlobalMessage,
  themeMode,
} from "@/features/systemSlice";
import { useDispatch, useSelector } from "react-redux";

import { removeUser } from "@/features/userSlice";

// Snackbar
import api from "@/lib/Api";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar from "@mui/material/Snackbar";

// const ColorModeContext = React.createContext({ toggleColorMode: () => {} });

function Transition(props) {
  return <Slide {...props} direction="down" />;
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Layout(props) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const location = useLocation();
  const { pathname } = location;
  const splitPath = pathname.split("/");
  const matchMediaQuery = useMediaQuery(theme.breakpoints.down("lg"));

  // Navigate
  const navigate = useNavigate();
  //const colorMode = React.useContext(ColorModeContext);

  const storage = window.localStorage;

  // States
  const { open, setOpen } = props;
  let {
    snackMessage,
    snackSeverity = "success",
    snackOpen,
    snackClose,
  } = props;
  //const [mode, setMode] = React.useState("light");
  const userUrl = useSelector((state) => state.user.userUrl);

  const themeModeChange = useSelector((state) => state.system.themeMode);
  const collapseOpen = useSelector((state) => state.system.collapseOpen);
  const globalMessage = useSelector((state) => state.system.globalMessage);
  if (globalMessage.code) {
    snackOpen = true;
    snackSeverity = globalMessage.isError ? "error" : "success";
    snackMessage = globalMessage.isError
      ? `${globalMessage.message} (CODE:${globalMessage.code})`
      : `${globalMessage.message}`;
    snackClose = () => {
      dispatch(setGlobalMessage({ message: {} }));
    };
  }

  const navigations = [
    {
      items: [
        {
          name: "主頁",
          url: "/",
          icon: <HomeIcon />,
        },
        {
          name: "銷售追蹤",
          url: "/daily",
          icon: <LocalOfferOutlinedIcon />,
        },
        // {
        //   name: "退貨查詢",
        //   url: "/refund",
        //   index: 9,
        //   icon: <OutboxIcon />,
        // },
        // {
        //   name: "換貨清單",
        //   url: "/exchangeInvoice",
        //   index: 25,
        //   icon: <MoveDownIcon />,
        // },
        // {
        //   name: "退倉清單",
        //   url: "/returnInvoice",
        //   index: 23,
        //   icon: <FlipToBackIcon />,
        // },
        // {
        //   name: "倉存管理",
        //   url: "/stockOnHandManage",
        //   index: 21,
        //   icon: <Inventory2OutlinedIcon />,
        // },

        // {
        //   name: "倉存管理",
        //   url: "/sohManage",
        //   index: 10,
        //   icon: <Inventory2OutlinedIcon />,
        // },
        // {
        //   name: "補貨請求",
        //   url: "/refillRequest",
        //   index: 4,
        //   icon: <MoveToInboxIcon />,
        // },
        // {
        //   name: "運送管理",
        //   url: "/deliveryOrder",
        //   index: 20,
        //   icon: <Receipt />,
        // },

        // {
        //   name: "運送管理",
        //   url: "/deliveryOrder",
        //   nested: [
        //     {
        //       name: "運送單",
        //       url: "/deliveryOrder",
        //       index: 17,
        //       icon: <Receipt />,
        //     },
        //     {
        //       name: "組合運送單",
        //       url: "/mergeDeliveryOrder",
        //       index: 18,
        //       icon: <CallMerge />,
        //     },
        //   ],
        //   icon: <LocalShipping />,
        // },
        // {
        //   name: "盤點管理",
        //   url: "/stocktake",
        //   index: 19,
        //   icon: <WarehouseIcon />,
        // },
      ],
    },
    {
      items: [
        {
          name: "贈品管理",
          url: "/giveAway",
          icon: <CardGiftcardIcon />,
          nested: [
            {
              name: "登記清單",
              url: "/cutomerDaily",
              icon: <ReceiptLongIcon />,
            },
            {
              name: "補貨請求",
              url: "/refillRequest",
              icon: <MoveToInboxIcon />,
            },
            {
              name: "盤點",
              url: "/stocktake",
              icon: <WarehouseIcon />,
            },
            {
              name: "運送單",
              url: "/deliveryOrder",
              icon: <Receipt />,
            },
            {
              name: "倉存",
              url: "/stockOnHandManage",
              icon: <Inventory2OutlinedIcon />,
            },
            {
              name: "換貨",
              url: "/exchangeInvoice",
              icon: <MoveDownIcon />,
            },
            {
              name: "退倉",
              url: "/returnInvoice",
              icon: <FlipToBackIcon />,
            },
            {
              name: "退貨",
              url: "/refund",
              icon: <OutboxIcon />,
            },
            {
              name: "調貨",
              url: "/transferInvoice",
              icon: <SwapCallsIcon />,
            },
            {
              name: "顧客",
              url: "/customerManage",
              icon: <AccountBoxIcon />,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          name: "數據統計",
          url: "/statistics",
          icon: <EqualizerIcon />,
          nested: [
            {
              name: "儀表板(即時)",
              url: "/promoterDashboard",
              icon: <DashboardIcon />,
            },
            {
              name: "儀表板(萬寧)",
              url: "/manningsDashboard",
              icon: <DashboardIcon />,
            },
            {
              name: "萬寧數據",
              url: "/compareSales",
              icon: <AnalyticsIcon />,
            },
            {
              name: "店鋪銷售",
              url: "/shopSalesChart",
              icon: <LeaderboardIcon />,
            },
            {
              name: "P＆L",
              url: "/profitAndLoss",
              icon: <CurrencyExchangeIcon />,
            },
            {
              name: "P＆L(Table)",
              url: "/profitAndLoss/table",
              icon: <CurrencyExchangeIcon />,
            },
            {
              name: "產品銷售",
              url: "/productSalesChart",
              index: 32,
              icon: <StackedBarChartIcon />,
            },
            {
              name: "推廣日目標",
              url: "/promotionTargetStatistics",
              icon: <AnalyticsIcon />,
            },
            // {
            //   name: "產品走勢",
            //   url: "/productTrendChart",
            //   index: 33,
            //   icon: <TrendingUpIcon />,
            // },
            // {
            //   name: "折扣成效",
            //   url: "/disscountPerformance",
            //   index: 35,
            //   icon: <DiscountIcon />,
            // },
          ],
        },
      ],
    },
    {
      items: [
        {
          name: "市場推廣",
          url: "/maketing",
          icon: <CampaignIcon />,
          nested: [
            {
              name: "廣告頁",
              url: "/landing",
              icon: <SummarizeOutlinedIcon />,
            },
            // {
            //   name: "萬寧優惠頁",
            //   url: "/manningsLanding",
            //   index: 12,
            //   icon: <QrCodeIcon />,
            // },
            {
              name: "開支",
              url: "/expenses",
              icon: <RequestQuoteIcon />,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          name: "一般設定",
          url: "/generalSetting",
          icon: <SettingsIcon />,
          nested: [
            {
              name: "每月設定",
              url: "/monthlySetting",
              icon: <SettingsIcon />,
            },
            {
              name: "折扣設定",
              url: "/promotionSetting",
              icon: <MonetizationOnIcon />,
            },
            {
              name: "推廣日目標",
              url: "/promotionTarget",
              icon: <MonetizationOnIcon />,
            },
            {
              name: "產品",
              url: "/productManage",
              icon: <PaymentsIcon />,
            },
            {
              name: "贈品",
              url: "/giveAwayManage",
              icon: <RedeemIcon />,
            },
            {
              name: "店舖",
              url: "/workLocationManage",
              icon: <BusinessIcon />,
            },
            {
              name: "更表",
              url: "/roster",
              icon: <CalendarMonthIcon />,
            },
            {
              name: "上班紀錄",
              url: "/checkin",
              icon: <ScheduleIcon />,
            },
            {
              name: "內部公告",
              url: "/notice",
              icon: <SummarizeOutlinedIcon />,
            },
            // {
            //   name: "推廣記錄",
            //   url: "/productDiscount",
            //   index: 2,
            //   icon: <SellIcon />,
            // },
            // {
            //   name: "萬寧優惠頁",
            //   url: "/manningsLanding",
            //   icon: <QrCodeIcon />,
            // },
            {
              name: "推播設定",
              url: "/pushNotification",
              index: 2,
              icon: <NotificationsNoneIcon />,
            },
            // {
            //   name: "推廣記錄",
            //   url: "/productDiscount",
            //   index: 2,
            //   icon: <SellIcon />,
            // },

            // {
            //   name: "推播設定",
            //   url: "/pushNotification",
            //   index: 2,
            //   icon: <NotificationsNoneIcon />,
            // },

            {
              name: "佣金",
              url: "/commission",
              icon: <AccountBalanceIcon />,
            },
          ],
        },
      ],
    },

    {
      items: [
        {
          name: "員工福利",
          url: "/employeeBenefit",
          icon: <LoyaltyIcon />,
          nested: [
            {
              name: "員工購物設定",
              url: "/employeePurchaseSetting",
              icon: <SettingsIcon />,
            },

            {
              name: "員工購物紀錄",
              url: "/employeePurchaseRecord",
              icon: <ListAltIcon />,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          name: "問卷調查",
          url: "/questionnarie",
          icon: <QuestionAnswerIcon />,
          nested: [
            {
              name: "問卷設定",
              url: "/questionnaireConfig",
              icon: <SettingsIcon />,
            },
            {
              name: "問卷記錄",
              url: "/questionnaireReportList",
              icon: <FormatListBulletedIcon />,
            },
            {
              name: "問卷記錄比較",
              url: "/questionnaireComparison",
              icon: <CompareIcon />,
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          name: "系統設定",
          url: "/systemSetting",
          icon: <AdminPanelSettingsIcon />,
          nested: [
            {
              name: "員工管理",
              url: "/staffManage",
              icon: <AssignmentIndOutlinedIcon />,
            },

            {
              name: "權限管理",
              url: "/roleAccessManage",
              icon: <SupervisorAccountIcon />,
            },
            {
              name: "IT權限管理",
              url: "/itItemPermission",
              icon: <ComputerIcon />,
            },
          ],
        },
      ],
    },
  ];
  // const colorMode = React.useMemo(
  //   () => ({
  //     toggleColorMode: () => {
  //       dispatch(themeMode(themeModeChange === "light" ? "dark" : "light"));
  //       //setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
  //     },
  //   }),
  //   [themeModeChange]
  // );
  React.useEffect(() => {
    storage.setItem("collapseOpen", JSON.stringify(collapseOpen));
  }, [collapseOpen]);
  const layoutTheme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: themeModeChange,
        },
        components: {
          MuiList: {
            styleOverrides: {
              root: {
                padding: "10px",
              },
            },
          },
          // MuiPaper: {
          //   styleOverrides: {
          //     root: {
          //       backgroundImage: "initial",
          //       backgroundColor: "initial",
          //     },
          //   },
          // },
          MuiListItemButton: {
            styleOverrides: {
              root: {
                borderRadius: "16px",
                "&.Mui-selected": {
                  backgroundColor: "#0A9C75",
                  color: "#FFFFFF",
                },
              },
            },
          },
          MuiListItemIcon: {
            styleOverrides: {
              root: {
                "&.Mui-selected": {
                  color: "#FFFFFF",
                },
              },
            },
          },
        },
      }),
    [themeModeChange]
  );

  // Drawer
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const themeChange = () => {
    dispatch(themeMode(themeModeChange === "light" ? "dark" : "light"));
  };
  const nestedClick = (index, isOpen) => {
    dispatch(setCollapseOpen({ index, isOpen }));
  };
  const logout = () => {
    dispatch(removeUser());
    localStorage.removeItem("collapseOpen");
    api.setToken();
    navigate("/login");
  };

  const onClickHandle = (path, index) => {
    dispatch(resetDataTable());
    navigate(path);
  };

  const renderListItem = (name, onClickPath, index, icon, nested) => {
    return (
      <ListItem key={index} disablePadding sx={{ display: "block" }}>
        <ListItemButton
          selected={
            onClickPath === pathname ||
            onClickPath.split("/")[1] === splitPath[1]
          }
          onClick={() => {
            if (nested) {
              nestedClick(onClickPath, !collapseOpen[onClickPath]);
            } else {
              onClickHandle(onClickPath);
              matchMediaQuery && handleDrawerClose();
            }
          }}
          sx={{
            minHeight: 48,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
              color:
                onClickPath === pathname ||
                onClickPath.split("/")[1] === splitPath[1]
                  ? "#FFFFFF"
                  : "auto",
            }}
          >
            {icon}
          </ListItemIcon>
          <ListItemText primary={name} sx={{ opacity: open ? 1 : 0 }} />
          {nested && (
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 3 : "auto",
                justifyContent: "center",
                color:
                  onClickPath === pathname ||
                  onClickPath.split("/")[1] === splitPath[1]
                    ? "#FFFFFF"
                    : "auto",
              }}
            >
              {collapseOpen[onClickPath] ? (
                <ArrowDropUpIcon />
              ) : (
                <ArrowDropDownIcon />
              )}
            </ListItemIcon>
          )}
        </ListItemButton>
        {nested && (
          <Collapse
            in={collapseOpen[onClickPath]}
            timeout="auto"
            unmountOnExit
            key={index}
          >
            <List component="div" disablePadding>
              {nested.map((nestedMenu, i) => {
                const foundPermission = userUrl.find(({ url }) =>
                  nestedMenu.url.includes(url)
                );
                if (foundPermission) {
                  return (
                    <Tooltip title={nestedMenu.name} placement="right" key={i}>
                      <ListItemButton
                        key={i}
                        sx={{ pl: 4 }}
                        selected={
                          nestedMenu.url === pathname ||
                          (nestedMenu.url.split("/")[1] === splitPath[1] &&
                            nestedMenu.url.split("/").length ===
                              splitPath.length)
                        }
                        onClick={() => {
                          onClickHandle(nestedMenu.url, nestedMenu.index);
                          matchMediaQuery && handleDrawerClose();
                        }}
                      >
                        <ListItemIcon>{nestedMenu.icon}</ListItemIcon>
                        <ListItemText primary={nestedMenu.name} />
                      </ListItemButton>
                    </Tooltip>
                  );
                }
                return <></>;
              })}
            </List>
          </Collapse>
        )}
      </ListItem>
    );
  };

  return (
    <ThemeProvider theme={layoutTheme}>
      <CssBaseline />
      <Box sx={{ display: "flex" }}>
        <Snackbar
          TransitionComponent={Transition}
          open={snackOpen}
          onClose={snackClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Alert
            severity={snackSeverity}
            sx={{ width: "100%", whiteSpace: "pre-line" }}
          >
            <Typography>
              {props.href ? (
                <Link color="inherit" href={props.href}>
                  {snackMessage}
                </Link>
              ) : (
                snackMessage
              )}
            </Typography>
          </Alert>
        </Snackbar>
        {/* AppBar */}
        <StyledAppBar position="fixed" open={open}>
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: open ? "flex-end" : "space-between",
              alignItems: "center",
            }}
          >
            <IconButton
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(open && { display: "none" }) }}
            >
              <MenuIcon />
            </IconButton>
            {/* <IconButton onClick={themeChange}>
              {themeModeChange === "light" ? (
                <LightModeIcon />
              ) : (
                <DarkModeIcon />
              )}
            </IconButton> */}
            <IconButton onClick={logout}>
              <LogoutIcon />
            </IconButton>
          </Toolbar>
        </StyledAppBar>

        {/* Drawer */}
        <Drawer
          sx={{
            width: 240,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: 240,
              boxSizing: "border-box",
              borderRight: 0,
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          {/* DrawerHeader */}
          <StyledDrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "ltr" ? (
                <ChevronLeftIcon />
              ) : (
                <ChevronRightIcon />
              )}
            </IconButton>
          </StyledDrawerHeader>
          {open && <img src={"/image/logo.png"} alt="logo" />}
          {navigations.map((navigation, index) => {
            return (
              <React.Fragment key={index}>
                {navigation.items.map((item) => {
                  const foundPermission = userUrl.find(
                    ({ url }) => url === item.url
                  );
                  const foundNested =
                    item.nested &&
                    item.nested.find(
                      (nested) =>
                        userUrl.find((user) => user.url === nested.url) &&
                        nested
                    );
                  if (
                    foundPermission ||
                    foundNested ||
                    (userUrl[0] && item.url === "/")
                  ) {
                    return renderListItem(
                      item.name,
                      item.url,
                      item.index,
                      item.icon,
                      item?.nested
                    );
                  }
                  return <></>;
                })}
              </React.Fragment>
            );
          })}
        </Drawer>
        <StyledMain open={open}>
          <StyledDrawerHeader />
          <Container maxWidth="xl">{props.children}</Container>
        </StyledMain>
        {/* Children Display */}
        {/* <Box component="main" sx={{ flexGrow: 1 }}>
        <StyledDrawerHeader />
        <Container maxWidth="xl">{props.children}</Container>
      </Box> */}
      </Box>
    </ThemeProvider>
  );
}
